import Icon from '@components/v2/ui/Icon/Icon';
import LabeledChip from '@components/v2/ui/LabeledChip/LabeledChip';
import { LabeledChipAppearance } from '@components/v2/ui/LabeledChip/labeledChip.styles';
import { Star } from 'lucide-react';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../../modules/translation/TranslationContext';

interface SuggestedProductTagProps {
  quantity?: number;
  useSuffix?: boolean;
  variant?: LabeledChipAppearance;
  className?: string;
}

const SuggestedProductTag = ({
  quantity,
  useSuffix = false,
  variant,
  className,
}: SuggestedProductTagProps) => {
  const { translate } = useTranslation();

  const getLabel = () => {
    if (!quantity) {
      return useSuffix ? translate(LangEnum.GLOBAL_SUGGESTED_SINGULAR) : undefined;
    }

    return useSuffix
      ? `${quantity} ${translate(LangEnum.GLOBAL_SUGGESTED_FEMALE_PLURAL)}`
      : `${quantity}`;
  };

  const label = getLabel();
  const message = quantity
    ? translate(LangEnum.ORDER_PRODUCT_GRID_SUGGESTED_PIECES, { quantity })
    : undefined;

  return (
    <LabeledChip
      content={label}
      appearance={variant}
      tooltip={message}
      title={message}
      className={className}
      icon={<Icon icon={Star} size="xs" />}
    />
  );
};

export default SuggestedProductTag;
